// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"_28suD","center":"P9DIp","backBtn":"cxi2r"};